export type WhatsappPhoneConnectionMessages = {
  whatsappPhoneConnectionText1Part1: string;
  whatsappPhoneConnectionText1Part2: string;
  whatsappPhoneConnectionText1Part3: string;
  whatsappPhoneConnectionPinError: string;
  whatsappPhoneConnectionInformPin: string;
  whatsappPhoneConnectionSomethingWentWrong: string;
  whatsappPhoneConnectionActivateNumber: string;
};

export const whatsappPhoneConnectionMessages: WhatsappPhoneConnectionMessages = {
  whatsappPhoneConnectionText1Part1: "Seu perfil do WhatsApp foi criado!",
  whatsappPhoneConnectionText1Part2:
    "Agora é necessário ativar seu número, defina um PIN (código numérico de 6 dígitos) e clique em ativar número.",
  whatsappPhoneConnectionText1Part3: "Clique em ativar número para continuar.",
  whatsappPhoneConnectionPinError: "Pin deve conter 6 dígitos numéricos",
  whatsappPhoneConnectionInformPin: "Informe o pin",
  whatsappPhoneConnectionSomethingWentWrong: "Algo deu errado.",
  whatsappPhoneConnectionActivateNumber: "Ativar número",
};
